import {
	HttpRequest, HttpHandler, HttpEvent, HttpInterceptor
}                                       from '@angular/common/http';
import {Injectable}                     from '@angular/core';

import {Observable}                     from 'rxjs/Observable';


@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {

	/**
	 * Add credentials to HttpRequests so cookie-based authentication
	 * will work.
	 *
	 * @param {HttpRequest<any>} request   An outgoing Http request.
	 * @param {HttpHandler} next           The handler starts the request.
	 * @return {Observable<HttpEvent<any>>}   The response from the Http request that gets passed back to the program.
	 */
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		// Always use credentials because this is cookie-based authentication.
		const authReq = request.clone( { withCredentials: true } );

		// Perform the Http request and monitor the results.
		return next.handle(authReq);

	}
}


// WEBPACK FOOTER //
// ./src/app/interceptors/credentials.interceptor.ts